<template>
  <div class="wrapper">
    <div class="content-wrapper">
      <div class="header-box" style="background: #fff; padding: 5px 10px; margin-bottom: 10px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item><span @click="handleChid(0)" :class="{'blue-action': parent_id}">一级分类</span></el-breadcrumb-item>
          <el-breadcrumb-item v-if="parent_id">二级分类</el-breadcrumb-item>
        </el-breadcrumb>
          
        <el-button @click="handleAdd" size="medium" type="primary">新增分类</el-button>
      </div>
      <div class="category-list">
        <!-- 分类列表 -->
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column prop="createTime" label="创建时间">
            <template slot-scope="scope">
              {{ timeFormat(scope.row.create_at) }}
            </template>
          </el-table-column>

          <el-table-column prop="sort_name" label="分类名称"> </el-table-column>

          <el-table-column label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                @click="popDelBox(scope.row)"
                type="text"
                size="small"
                >删除
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="handleEdit(scope.row)"
                >编辑
              </el-button>
              <el-button
                v-if="scope.row.parent_id === 0"
                type="text"
                size="small"
                @click="handleChid(scope.row.id)"
                >二级分类
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--</div>-->
      <!-- 删除分类 -->
      <el-dialog
        :visible.sync="delBox"
        :before-close="handleDelCancel"
        title="删除分类"
        width="450px"
      >
        <p class="title">确认删除分类?</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDel">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 新增、编辑分类弹框 -->
      <el-dialog
        :visible.sync="dialogVisible"
        :before-close="handleCancel"
        width="50%"
      >
        <div slot="title">{{ title }}</div>
        <el-input
          maxlength="14"
          minlength="1"
          v-model="sortName"
          placeholder="请输入分类名称"
        ></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancel">取 消</el-button>
          <el-button type="primary" @click="handleSort">确 定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import Common from "./assets/scripts/common.js";
import {getCommonList} from './common'

export default {
  name: "category",
  data() {
    return {
      parent_id: 0,
      tableData: [],
      setTableData: [],
      dialogVisible: false,
      sortName: "",
      handleType: "", //操作分类的类型 'add'新增分类 'edit'编辑分类
      title: "",
      delBox: false,
      delData: {},
      tableLoading: true,
      // 分享相关变量
      shareBox: false, //分享弹框显示
      shareLink: {}, //分享链接
      selecetedId: "" //默认加载的分类ID
    };
  },
  methods: {
    handleChid(id) {
      this.parent_id = id
      this.getSortList()
    },
    handleAdd() {
      this.dialogVisible = true
      this.title = '新增分类'
      this.handleType = 'add'
    },
    handleEdit(row) {
      this.dialogVisible = true
      this.title = '编辑分类'
      this.handleType = 'edit'
      this.sortId = row.id
    },
    //新增/编辑分类
    handleSort: function() {
      let that = this;
      let handleType = this.handleType;
      let sortName = (this.sortName || "").replace(/\s/g, "");
      if (sortName && handleType == "add") {
        lib.tmsapi.post({
          api: "api/test/material_category/add",
          data: {
            category_name: sortName,
            parent_id: that.parent_id || 0
          },
          success: res => {
            // 提示成功
            Message.success({
              message: "添加分类成功",
              type: "info",
              center: true
            });
            // 添加成功，刷新列表
            that.getSortList();

            // 关闭弹框
            that.dialogVisible = false;
            // 清楚输入框内容
            that.sortName = "";
          }
        });
      }

      if (sortName && handleType == "edit") {
        lib.tmsapi.post({
          api: "api/test/material_category/update",
          data: {
            category_name: sortName,
            id: that.sortId
          },
          success: res => {
            // 提示成功
            Message.success({
              message: "修改分类成功",
              type: "info",
              center: true
            });
            // 修改成功，刷新列表
            that.getSortList();

            // 关闭弹框
            that.dialogVisible = false;
            // 清楚输入框内容
            that.sortName = "";
            // 清楚handleType
            that.handleType = "";
          }
        });
      }
    },
    // dialog取消按钮更改状态
    handleCancel: function() {
      this.dialogVisible = false;
      this.handleType = "";
      this.sortName = "";
      this.sortId = "";
    },
    // 分享该分类
    popShareBox: function(data, type) {
      this.tableLoading = true;
      switch (type) {
        case "share":
          let sortId = data.sort_id;
          lib.tmsapi.post({
            api: "api/test/sort/share",
            data: {
              shared: true,
              sortId: sortId
            },
            success: res => {
              this.tableLoading = false;
              // 提示成功
              Message.success({
                message: "分享分类成功",
                type: "info",
                center: true
              });
              // 修改成功，刷新列表
              this.getSortList();
            }
          });

          break;

        case "cancel":
          lib.tmsapi.post({
            api: "api/test/sort/share",
            data: {
              shared: false,
              sortId: data.sort_id
            },
            success: res => {
              this.tableLoading = false;
              // 提示成功
              Message.success({
                message: "取消分享分类成功",
                type: "info",
                center: true
              });
              // 修改成功，刷新列表
              this.getSortList();
            }
          });
          break;

        case "copy":
          let url = location.origin + "/pic?sort_id=" + data.sort_id;
          const input = document.createElement("input");
          document.body.appendChild(input);
          input.setAttribute("value", url);
          input.setAttribute("display", "none");
          input.select();
          if (document.execCommand("copy")) {
            document.execCommand("copy");
            Message.success({
              message: "已复制",
              type: "info",
              center: true
            });
            this.tableLoading = false;
          }
          document.body.removeChild(input);
      }
    },
    // 复制分享链接功能
    copyLink: function() {},
    // 隐藏分享弹框
    handleShareCancel: function() {
      this.shareBox = false;
    },
    // 获取分类列表
    async getSortList() {
      this.tableData = await getCommonList(this.parent_id)
    },

    // 点击删除弹框
    popDelBox: function(data) {
      if (!this.delBox) {
        this.delData = { ...data };
        this.delBox = true;
      }
    },
    // 取消删除
    handleDelCancel: function() {
      this.delBox = false;
      this.delData = {};
    },
    // 删除一条分类
    handleDel: function(data) {
      let that = this;
      let id = this.delData.id;
      let params = {
        id
      };
      if(this.tableData.length <= 1) {
        this.$message.error('必须有一个子类目')
        return
      }
      if (!id) {
        return false;
      }

      lib.tmsapi.post({
        api: "api/test/material_category/del",
        data: params,
        success: res => {
          // 关闭弹框
          that.delBox = false;
          Message.success({
            message: "删除分类成功",
            type: "info",
            center: true
          });
          // 添加成功，刷新列表
          that.getSortList()
        }
      });
    },
    // 时间戳格式化
    timeFormat: function(date) {
      return Common.formatTime(date);
    }
  },
  mounted() {
    this.getSortList();
  }
};
</script>
<style scoped>
.header-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content-wrapper {
  margin: 20px auto;
  width: 70%;
}

.title {
  text-align: center;
  font-size: 16px;
}
.blue-action{
  cursor: pointer;
  color: #409EFF;
}

</style>
